import { Component, OnInit } from '@angular/core';
import { PortfolioService } from '../../portfolios/shared/services/portfolio.service';
import { PortfolioModel } from '../../portfolios/shared/models/portfolio-model';

@Component({
  selector: 'hr-dashboard-shell',
  templateUrl: './dashboard-shell.component.html',
  styleUrls: ['./dashboard-shell.component.less'],
  standalone: false,
})
export class DashboardShellComponent implements OnInit {
  ownPortfolios: PortfolioModel[];

  constructor(private portfolioService: PortfolioService) {}

  ngOnInit() {
    this.portfolioService.listOwnPortfolios().subscribe((d) => {
      this.ownPortfolios = d.items;
    });
  }
}
